<template>
  <div>
    <div class="inputview">
      <div>
        <b-field>
          <b-autocomplete
            :expanded="false"
            ref="input"
            rounded
            v-model="name"
            :data="filteredDataArray"
            :keep-first="true"
            :clear-on-select="true"
            placeholder="input transliteral"
            field="transliteral"
            @keydown.native.right.prevent="Confirm('right')"
            @keydown.native.left.prevent="Confirm('left')"
            @keydown.native.189.prevent="Confirm('-')"
            @keydown.native.190.prevent="Confirm('.')"
            @keydown.native.space.prevent="Confirm('space')"
            @keydown.native.enter.prevent="Confirm('enter')"
            @select="optionSelected"
          >
            <template slot="empty">No results found</template>
            <template slot-scope="props">
              <span>{{ props.option.transliteral }} </span>
              <span :style="cuneistyle" class="is-size-5"
                >{{ props.option.cuneiform }}
              </span>
              <span v-if="false" class="is-size-7"
                >{{ props.option.search_score }}
              </span>
            </template>
          </b-autocomplete>
        </b-field>
      </div>
      <div id="result" style="word-wrap: break-word">
        <div>
          <trans-literal
            v-for="(item, index) in text"
            :key="index"
            :word="item.transliteral"
          />
        </div>
        <div :style="cuneistyle">
          <span
            :class="cuneifontsize"
            v-for="(item, index) in text"
            :key="index"
          >
            <span v-if="item.cuneiform" class="sign" @click="select(item)">
              {{ item.cuneiform }}</span
            ></span
          >
        </div>
      </div>
    </div>

    <div>
      <button class="button is-small" @click="clear()">Clear Text</button>
      <button class="button is-small" @click="cuneifontsize = 'is-size-1'">
        Large
      </button>
      <button class="button is-small" @click="cuneifontsize = 'is-size-4'">
        Normal
      </button>
      <button class="button is-small" @click="cuneifontsize = 'is-size-6'">
        Small
      </button>
    </div>

    <div v-if="selectedSign">
      <sign-info :sign="selectedSign" :cuneistyle="cuneistyle" />
      <div v-if="huburData">
        <hr />
        <div v-for="dat in huburData.slice(0, 10)">
          <hubur-result :value="dat" :cuneistyle="cuneistyle" />
          <hr />
        </div>
        <div class="is-size-4">
          <a
            :href="`https://hubur.kurnugia.com/?input=${selectedSign.cuneiform}`"
            target="_blank"
            >More Data...</a
          >
        </div>
      </div>
      <div v-else>
        <button
          class="button is-small"
          @click="searchDictionary(selectedSign.cuneiform)"
        >
          Search from Sumerian Dictionary
        </button>
      </div>
    </div>
    <div class="fontSelector">
      <div>Select Cuneiform Font</div>

      <div style="padding: 1rem" class="font-selector">
        <b-radio v-model="cuneifont" native-value=""> Sumer (UrIII) </b-radio>
        <b-radio v-model="cuneifont" native-value="santakku">
          Old Babylonian (cursive)
        </b-radio>
        <b-radio v-model="cuneifont" native-value="santakkuM">
          Old Babylonian (monumental)
        </b-radio>

        <b-radio v-model="cuneifont" native-value="assurbanipal">
          Neo Assyria (A)
        </b-radio>
        <b-radio v-model="cuneifont" native-value="sinacheribmod">
          Neo Assyria (B)
        </b-radio>
        <b-radio v-model="cuneifont" native-value="esagil">
          Neo Babylonia
        </b-radio>
        <b-radio v-model="cuneifont" native-value="ullikummiA">
          Hittite
        </b-radio>
      </div>
      <div class="fontinfo" style="padding: 1rem">
        <template v-if="cuneifont === ''">
          <p>Sumerian Cuneiform Font</p>
          <a href="https://www.google.com/get/noto/"> Noto Sans Cuneiform </a>
        </template>
        <template v-else-if="cuneifont === 'santakku'">
          <p>Old Babylonian Font</p>
          <a href="https://www.hethport.uni-wuerzburg.de/cuneifont/">
            Santakku
          </a>
        </template>
        <template v-else-if="cuneifont === 'santakkuM'">
          <p>Old Babylonian Monumental Font</p>
          <a href="https://www.hethport.uni-wuerzburg.de/cuneifont/">
            SantakkuM
          </a>
        </template>
        <template v-else-if="cuneifont === 'assurbanipal'">
          <p>Neo Assyrian Cuneiform Font</p>
          <a href="https://www.hethport.uni-wuerzburg.de/cuneifont/"
            >Assurbanipal</a
          >
        </template>
        <template v-else-if="cuneifont === 'sinacheribmod'">
          <p>Another Neo Assyrian Cuneiform Font</p>
          <a href="http://home.zcu.cz/~ksaskova/">Sinacherib</a>
        </template>
        <template v-else-if="cuneifont === 'esagil'">
          <p>Neo Babylonian Cuneiform Font</p>
          <a href="https://www.hethport.uni-wuerzburg.de/cuneifont/">Esagil</a>
        </template>
        <template v-else-if="cuneifont === 'ullikummiA'">
          <p>Hittite Cuneiform Font</p>
          <a href="https://www.hethport.uni-wuerzburg.de/cuneifont/"
            >UllikummiA</a
          >
        </template>
      </div>
    </div>

    <div class="share">
      <b-loading
        :is-full-page="true"
        :active.sync="isShareBusy"
        :can-cancel="false"
      ></b-loading>
      <div class="buttons">
        <b-button @click="share" icon-left="link-variant"> Share </b-button>

        <b-button @click="downloadImage" icon-left="file-image">
          Download Image
        </b-button>
      </div>

      <b-input v-show="shareUrl !== ''" :value="shareUrl"> </b-input>
    </div>
  </div>
</template>

<style>
div.inputview {
  padding-bottom: 2rem;
}

div.fontSelector {
  margin-top: 1rem;
  padding: 1rem;
  border: solid 1px gray;
  border-radius: 10px;
}

div.share {
  padding: 1rem;
}
</style>

<script>
import TransLiteral from "./TransLiteral.vue";
import SignInfo from "./SignInfo.vue";
import HuburResult from "./HuburResult.vue";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore/lite";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

import nanoid from "nanoid";
var config = {
  apiKey: "AIzaSyCN_hhyDSsf30Wa1Zj04euv1OqC-TFETS4",
  authDomain: "qantuppi.firebaseapp.com",
  databaseURL: "https://qantuppi.firebaseio.com",
  projectId: "qantuppi",
  storageBucket: "qantuppi.appspot.com",
  messagingSenderId: "350181973518",
};
const app = initializeApp(config);
const db = getFirestore(app);

const signlist = require("@/data/signlist.json");
export default {
  name: "InputAid",

  components: {
    TransLiteral,
    SignInfo,
    HuburResult,
  },

  data() {
    return {
      data: [],
      name: "",
      selected: null,
      text: [],
      selectedFont: "",
      importedFont: [],
      cuneistyle: {
        "font-family": "serif",
        "letter-spacing": "2px",
      },
      cuneifont: "",
      cuneifontsize: "is-size-4",
      shareEnable: true,
      isShareBusy: false,
      shareUrl: "",
      capturedData: "",
      selectedSign: null,
      huburData: null,
      huburCache: {},
    };
  },

  props: {
    sharedId: String,
  },

  async created() {
    console.log("sharedId=" + this.sharedId);
    if (this.sharedId !== "") {
      const card = await db.collection("cards").doc(this.sharedId).get();
      if (card.exists) {
        const data = card.data();
        this.text = data.text;
        if (data.cuneifont) {
          this.cuneifont = data.cuneifont;
        }
        if (data.cuneifontsize) {
          this.cuneifontsize = data.cuneifontsize;
        }
      }
    }
  },

  computed: {
    dataArray() {
      if (!this.name.length) return [];
      const start = performance.now();
      const search_text = this.name.toLowerCase();
      let result = [];
      for (const sign of signlist) {
        if (sign.name_search && sign.name_search.length) {
          const score_offset =
            (sign.name.length - sign.name_search.length) * 0.3;
          const score = this.score(
            sign.name_search,
            search_text,
            sign.score + score_offset
          );
          if (score >= 0) {
            result.push(
              Object.assign(
                {
                  transliteral: sign.name,
                  search_score:
                    score -
                    (this.name[0] === this.name[0].toUpperCase() ? 0.5 : 0),
                },
                sign
              )
            );
            if (sign.name.search(/(\s|\.)/) == -1) {
              result.push(
                Object.assign(
                  {
                    transliteral: sign.name.toLowerCase(),
                    search_score:
                      score -
                      (this.name[0] === this.name[0].toLowerCase() ? 0.5 : 0),
                  },
                  sign
                )
              );
            }
          }
        }

        if (sign.alt_names_search) {
          sign.alt_names_search.forEach((name, i) => {
            if (name && name.length) {
              const score_offset =
                (sign.alt_names[i].length - name.length) * 0.3;
              const score = this.score(
                name,
                search_text,
                sign.score + score_offset
              );
              if (score >= 0) {
                result.push(
                  Object.assign(
                    {
                      transliteral: sign.alt_names[i],
                      search_score:
                        score -
                        (this.name[0] === this.name[0].toUpperCase() ? 0.5 : 0),
                    },
                    sign
                  )
                );
                if (sign.alt_names[i].search(/(\s|\.)/) == -1) {
                  result.push(
                    Object.assign(
                      {
                        transliteral: sign.alt_names[i].toLowerCase(),
                        search_score:
                          score -
                          (this.name[0] === this.name[0].toLowerCase()
                            ? 0.5
                            : 0),
                      },
                      sign
                    )
                  );
                }
              }
            }
          });
        }
      }
      result.sort((a, b) => a.search_score - b.search_score);

      return result;
    },
    filteredDataArray() {
      const list = this.dataArray;

      if (list.length < 30) {
        return list;
      } else {
        return list.slice(0, 50);
      }
    },

    transliterals() {
      return this.text.map((x) => x.transliteral).join("");
    },
    cuneiforms() {
      return this.text.map((x) => x.cuneiform).join("");
    },
  },
  methods: {
    select(sign) {
      this.selectedSign = sign;
      this.huburData = this.huburCache[sign.cuneiform];
    },

    clear() {
      this.text = [];
      this.selectedSign = null;
    },

    async searchDictionary(text) {
      const query = new URLSearchParams({
        text: text,
      });
      fetch("https://hubur.kurnugia.com/api/orth?" + query)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          this.huburCache[text] = data.data;
          this.huburData = data.data;
        });
    },

    score(text, search_text, base_score) {
      let search = search_text.replace("c", "s").replace("j", "g");

      const index = text.indexOf(search);
      if (index < 0) return -1;
      if (text.length == search.length) {
        return base_score;
      }

      const baselen = text.replace(/\d+$/, "").length;
      const score = index * 10 + baselen - search.length;
      if (score < 0) return base_score + 0.5;
      return base_score + score + 0.5;
    },

    keyInput(e) {
      this.$refs.input.value += e;
    },
    re_match(re, ts) {
      var match = ts.match(re);
      return match ? match[1] : "";
    },
    Confirm(e) {
      console.log("confirm:" + e);

      const option = this.$refs.input.$data.hovered;
      if (this.name && option != null) {
        this.text.push(option);
        this.$gtag.event("confirm");
        this.$ga.event("input", "confirm", "cuneiform");
      }

      switch (e) {
        case "right":
        case "left":
          break;
        case "space":
          this.text.push({
            transliteral: " ",
            cuneiform: "",
            transcript: " ",
          });
          break;
        case "enter":
          break;
        default:
          this.text.push({
            transliteral: e,
            cuneiform: "",
            transcript: "",
          });
          break;
      }

      this.name = "";
    },

    optionSelected(option) {
      console.log("selected:", option);
      if (option != null) {
        this.text.push(option);
        this.select(option);
      }
      this.name = "";
      if (option !== null) {
        this.$ga.event("confirm");
        this.$ga.event("input", "confirm", "cuneiform");
      }
    },

    async share() {
      this.isShareBusy = true;
      const element = this.$refs.capture;
      const scale = 2;

      var canvas = document.createElement("canvas");
      canvas.width = 600;
      canvas.height = 300;
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const leftMargin = 40;
      let xoffset = leftMargin;
      let yoffset = 80;
      let fontsize = 32;
      ctx.fillStyle = "#3d3932";
      ctx.strokeStyle = "#3d3932";

      this.text.forEach((x) => {
        console.log(xoffset, yoffset);
        const suptext = x.transliteral.match(/\{(.+)\}/);
        const subtext = x.transliteral.match(/\B([0-9x]+)/);
        const basetext = x.transliteral.replace(/(\{.+\}|\B[0-9x]+)/g, "");
        ctx.font = `400 ${fontsize}px sans-serif`;
        const basewidth = ctx.measureText(basetext).width;
        if (xoffset + basewidth + 40 > canvas.width) {
          xoffset = leftMargin;
          yoffset = yoffset + fontsize * 1.2;
        }
        console.log(xoffset, yoffset);

        if (suptext) {
          const text = suptext[1];
          ctx.font = `600 ${fontsize * 0.6}px sans-serif`;
          const width = ctx.measureText(text).width;
          ctx.fillText(text, xoffset, yoffset - fontsize * 0.44);
          xoffset += width;
        }
        if (basetext !== "") {
          ctx.font = `400 ${fontsize}px sans-serif`;
          ctx.fillText(basetext, xoffset, yoffset);
          xoffset += basewidth;
        }
        if (subtext) {
          const text = subtext[1];
          ctx.font = `600 ${fontsize * 0.6}px sans-serif`;
          const width = ctx.measureText(text).width;
          ctx.fillText(text, xoffset, yoffset + fontsize * 0.16);
          xoffset += width;
        }
      });
      yoffset += 10;

      if (this.cuneifontsize === "is-size-6") {
        fontsize = 24;
      } else if (this.cuneifontsize === "is-size-1") {
        fontsize = 96;
      } else {
        fontsize = 48;
      }
      yoffset += fontsize;

      ctx.font =
        `${fontsize}px ` +
        (this.cuneifont === "" ? "'Source Sans Pro'" : this.cuneifont);
      console.log(ctx.font);

      let rows = [""];
      let line = 0;
      const text = this.cuneiforms;
      for (let i = 0; i < text.length; i++) {
        let char = text.charAt(i);

        if (
          ctx.measureText(rows[line] + char).width >
          canvas.width - leftMargin
        ) {
          line++;
          rows[line] = "";
        }
        rows[line] += char;
      }

      for (let j = 0; j < rows.length; j++) {
        ctx.fillText(rows[j], leftMargin, yoffset + fontsize * j);
      }

      this.capturedData = canvas.toDataURL();

      const user = await firebase.auth().signInAnonymously();

      const sRef = firebase.storage().ref();
      const id = nanoid();
      const fileRef = sRef.child(`${id}.png`);
      await fileRef.putString(this.capturedData, "data_url");
      const url = await fileRef.getDownloadURL();
      const card = db.collection("cards").doc(id);
      const docRef = await card.set(
        {
          url,
          text: this.text,
          transliteral: this.transliterals,
          cuneiform: this.cuneiforms,
          cuneifont: this.cuneifont,
          cuneifontsize: this.cuneifontsize,
        },
        { merge: false }
      );
      this.shareUrl = "https://qantuppi.firebaseapp.com/share/" + id;

      this.isShareBusy = false;
    },

    async downloadImage() {
      if (this.shareUrl === "") {
        await this.share();
      }
      let link = document.createElement("a");
      link.href = this.capturedData;
      link.download = "cuneiform.png";
      link.click();
    },
  },

  watch: {
    cuneifont(val) {
      this.shareUrl = "";
      const fontname = val;
      console.log("select font:" + fontname);
      if (fontname === "") {
        this.cuneistyle["font-family"] = "'Source Sans Pro', sans-serif";
        this.selectedFont = "";
      } else {
        if (!(fontname in this.importedFont)) {
          console.log("import");
          this.importedFont.push(fontname);
          import(`@/assets/scss/${fontname}.scss`);
        }
        this.cuneistyle["font-family"] = fontname;
        this.selectedFont = fontname;
      }
      this.$gtag.event("font-select", { select: fontname });
      this.$ga.event("font-select", "select", fontname);
    },
    text(val) {
      this.shareUrl = "";
    },
    cuneifontsize(val) {
      this.shareUrl = "";
    },
  },
};
</script>

<style lang="scss">
.font-selector {
  label {
    margin-bottom: 10px;
  }
  span.control-label {
    display: inline-block;
    width: 130px;
  }
}
.fontinfo {
  a {
    font-weight: 800;
  }
}
@mixin hover {
  @media (hover: none) {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    &:active {
      @content;
    }
  }

  @media (-ms-high-contrast: none),
    (-ms-high-contrast: active),
    (-moz-touch-enabled: 0),
    (hover: hover) {
    &:hover {
      @content;
    }
  }
}

.sign {
  border-radius: 130px;

  @include hover {
    border: thick solid blue;
  }
}
</style>
